import { Vehicle } from "../graphql/generated/graphql";
import { getBundleDiscount, getBundleDiscountPercent } from "./bundles";
import {
  RENEW_MAX_DISCOUNTED,
  RENEW_MAX_STANDARD,
  // RENEW_PLUS_DISCOUNTED,
  // RENEW_PLUS_STANDARD,
  TIER_KEYS,
  VALID_PURCHASES,
  ValidPurchaseDataType,
} from "./constants";

// The following two functions are currently equal, but they are apart in case we change the renewal logic
export function hasMaxRenewDiscount(previousTier, renewCount) {
  return previousTier === TIER_KEYS.MAX && renewCount < 1;
}

export function hasPlusRenewDiscount(previousTier, renewCount) {
  return false; //previousTier === TIER_KEYS.PLUS && renewCount < 1;
}

type getPurchaseMetaDataResult = {
  data: ValidPurchaseDataType;
  purchaseId: string;
  quantity: number;
  isRenew: boolean;
  renewType: string;
  bundle: Record<string, number>;
  subtotal: number;
  bundleDiscount: number;
  discountPercent: number;
  total: number;
};
export function getPurchaseMetaData(
  purchase: string,
  discountInfo?: { percentOff: number; discountCode: string },
  vehicleData?: Vehicle
): getPurchaseMetaDataResult {
  const {
    id: purchaseId,
    qty = 1,
    isRenew,
    renewType,
  } = VALID_PURCHASES[purchase];

  let validPurchaseId = purchaseId;

  if (
    isRenew &&
    vehicleData &&
    (!hasMaxRenewDiscount(vehicleData?.previousTier, vehicleData?.renewCount) ||
      !hasPlusRenewDiscount(vehicleData?.previousTier, vehicleData?.renewCount))
  ) {
    // if (purchaseId === RENEW_PLUS_DISCOUNTED.id) {
    //   validPurchaseId = RENEW_PLUS_STANDARD.id;
    // } else
    if (purchaseId === RENEW_MAX_DISCOUNTED.id) {
      validPurchaseId = RENEW_MAX_STANDARD.id;
    }
  }

  const purchaseData = VALID_PURCHASES[validPurchaseId];
  const [itemId] = purchase.split("_");
  const bundle = qty > 1 && purchaseData.bundleDiscounts;
  const bundleDiscount = bundle ? getBundleDiscount(purchaseId, qty) : 0;
  //
  const subtotal = purchaseData.price * qty;
  const discountPercent = bundle
    ? getBundleDiscountPercent(purchaseId, qty)
    : discountInfo?.percentOff || 0;

  let total;

  if (bundle) {
    total = subtotal - subtotal * bundleDiscount;
  } else {
    if (discountInfo) {
      total = subtotal - (subtotal * discountInfo.percentOff) / 100;
    } else {
      total = subtotal;
    }
  }

  return {
    data: purchaseData,
    purchaseId: itemId,
    quantity: qty,
    isRenew,
    renewType,
    bundle,
    subtotal,
    bundleDiscount,
    discountPercent,
    total,
  };
}
